import React from "react";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import "./healthCare.css";
import KeyChallenges from "./KeyChallenges";
import KeyFeatures from "./KeyFeatures";
import HowItWorks from "./HowItWorks";
import TechnologyStack from "./TechnologyStack";
import CallToAction from "./CallToAction";
import Benefits from "./Benefits";

const HealthCare = () => {
  return (
    <div className="health-care-industry-wrapper">
      <Particles title="HealthCare" />
      <HeroSection />
      <KeyChallenges />
      <KeyFeatures />
      <Benefits />
      <HowItWorks />
      <TechnologyStack />
      <CallToAction />
    </div>
  );
};

export default HealthCare;
